import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import publicRoutes from './public';
import protectedRoutes from './protected';
// import commonRoutes from './common';

// TODO:
// https://ui.docs.amplify.aws/react/connected-components/authenticator/advanced

function AppRoutes() {
  const router = createBrowserRouter([...publicRoutes, ...protectedRoutes]);

  return <RouterProvider router={router} />;
}

export default AppRoutes;
